(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  function initCollectionStagger() {
    const items = document.querySelectorAll('.stagger-item');
    if (!items.length) return;
    items.forEach((item) => { item.classList.remove('is-visible'); });
    items.forEach((item, index) => {
      setTimeout(() => { item.classList.add('is-visible'); }, index * 80);
    });
  }

  document.addEventListener('DOMContentLoaded', initCollectionStagger, { once: true });
  document.addEventListener('shopify:section:load', initCollectionStagger);

  } catch(e) { console.error(e); }
})();
})();
